import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getMaterials
}
from "../../api/materialApi";

import {
  createAdjustment
}
from "../../api/stockAdjustmentApi";

const StockAdjustment = () => {

  const [materials,setMaterials] =
  useState([]);

  const [form,setForm] =
  useState({

    adjustment_type:
    "INCREASE",

    remarks:""

  });

  const [items,setItems] =
  useState([

    {
      material_id:"",
      quantity:""
    }

  ]);

  useEffect(()=>{

    loadMaterials();

  },[]);

  const loadMaterials =
  async()=>{

    try{

      const res =
      await getMaterials();

      setMaterials(
        res.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const addRow =
  ()=>{

    setItems([

      ...items,

      {
        material_id:"",
        quantity:""
      }

    ]);

  };

  const removeRow =
  (index)=>{

    const updated =
    [...items];

    updated.splice(
      index,
      1
    );

    setItems(updated);

  };

  const updateRow =
  (
    index,
    field,
    value
  )=>{

    const updated =
    [...items];

    updated[index][field] =
    value;

    setItems(updated);

  };

  const saveAdjustment =
  async(e)=>{

    e.preventDefault();

    try{

      await createAdjustment({

        adjustment_type:
        form.adjustment_type,

        remarks:
        form.remarks,

        items

      });

      alert(
        "Stock Adjustment Saved"
      );

      setItems([
        {
          material_id:"",
          quantity:""
        }
      ]);

      setForm({

        adjustment_type:
        "INCREASE",

        remarks:""

      });

    }
    catch(error){

      console.log(error);

      alert(
        "Failed To Save"
      );

    }

  };

  return(

    <MainLayout>

      <div className="card shadow-sm">

        <div className="card-header">

          <h5>
            Stock Adjustment
          </h5>

        </div>

        <div className="card-body">

          <form
            onSubmit={
              saveAdjustment
            }
          >

            <div className="row mb-4">

              <div className="col-md-4">

                <label>
                  Adjustment Type
                </label>

                <select
                  className="form-select"
                  value={
                    form.adjustment_type
                  }
                  onChange={(e)=>
                    setForm({

                      ...form,

                      adjustment_type:
                      e.target.value

                    })
                  }
                >

                  <option value="INCREASE">
                    Increase
                  </option>

                  <option value="DECREASE">
                    Decrease
                  </option>

                </select>

              </div>

              <div className="col-md-8">

                <label>
                  Remarks
                </label>

                <input
                  className="form-control"
                  value={
                    form.remarks
                  }
                  onChange={(e)=>
                    setForm({

                      ...form,

                      remarks:
                      e.target.value

                    })
                  }
                />

              </div>

            </div>

            <table className="table table-bordered">

              <thead>

                <tr>

                  <th>
                    Material
                  </th>

                  <th>
                    Quantity
                  </th>

                  <th>
                    Action
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  items.map(
                    (
                      item,
                      index
                    )=>(

                      <tr
                        key={index}
                      >

                        <td>

                          <select
                            className="form-select"
                            value={
                              item.material_id
                            }
                            onChange={(e)=>
                              updateRow(

                                index,

                                "material_id",

                                e.target.value

                              )
                            }
                          >

                            <option value="">
                              Select Material
                            </option>

                            {
                              materials.map(
                                material=>(

                                  <option
                                    key={
                                      material.id
                                    }
                                    value={
                                      material.id
                                    }
                                  >

                                    {
                                      material.material_name
                                    }

                                  </option>

                                )
                              )
                            }

                          </select>

                        </td>

                        <td>

                          <input
                            type="number"
                            className="form-control"
                            value={
                              item.quantity
                            }
                            onChange={(e)=>
                              updateRow(

                                index,

                                "quantity",

                                e.target.value

                              )
                            }
                          />

                        </td>

                        <td>

                          {
                            items.length > 1 &&
                            (

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={()=>
                                  removeRow(
                                    index
                                  )
                                }
                              >

                                Remove

                              </button>

                            )
                          }

                        </td>

                      </tr>

                    )
                  )
                }

              </tbody>

            </table>

            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={addRow}
            >

              Add Material

            </button>

            <button
              className="btn btn-primary"
            >

              Save Adjustment

            </button>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default StockAdjustment;